export function cleanNumber(value) {
  if (value == null || value === '') {
    return null;
  }
  if (typeof value === 'string') {
    return Number(value.replace(/\$|\%|\,/g, ''));
  }
  return value;
}
